import servicesProviders from './services/providers';
import servicelessProviders from './serviceless-providers/providers';

const providers = [
	...servicesProviders,
	...servicelessProviders,
];

export default providers;
